/**
 * Shared AI interface definitions to prevent circular dependencies.
 */

export interface BotResponse {
  intent: string;
  response: string;
  data?: any;
  nextIntent?: { name: string; params: any };
  systemLog?: string;
}

export interface APIResponse {
  response: string;
  model: string;
  provider: string;
  intent?: string;
  data?: any;
}

export interface AIContext {
  source?: string;
  provider?: string;
  modelId?: string;
  testKey?: string;
  silent?: boolean;
  skipReflection?: boolean;
  disableFallback?: boolean;
  messages?: { role: 'user' | 'ai' | 'system'; content: string }[];
}

export type AIProviderId = 'gemini' | 'openai' | 'claude' | 'minimax' | 'groq' | 'mistral' | 'cohere' | 'deepseek' | 'together' | 'local';

export interface AIProviderConfig {
  id: AIProviderId;
  name: string;
  iconName: string; // Name of icon to map in UI
  desc: string;
  color: string;
}

export interface APIKeys {
  gemini?: string | string[];
  openai?: string | string[];
  claude?: string | string[];
  minimax?: string | string[];
  groq?: string | string[];
  mistral?: string | string[];
  cohere?: string | string[];
  deepseek?: string | string[];
  together?: string | string[];
  [key: string]: string | string[] | undefined;
}

export const AI_PROVIDERS: AIProviderConfig[] = [
  { id: 'local', name: 'Neural Local', iconName: 'Cpu', desc: 'Private, 100% offline inference.', color: 'var(--t-primary)' },
  { id: 'openai', name: 'OpenAI', iconName: 'Zap', desc: 'Industry standard performance.', color: '#10a37f' },
  { id: 'claude', name: 'Claude', iconName: 'Infinity', desc: 'Superior reasoning & coding.', color: '#d97757' },
  { id: 'gemini', name: 'Google Gemini', iconName: 'Globe', desc: 'Large context, high speed.', color: '#4285f4' },
  { id: 'deepseek', name: 'DeepSeek', iconName: 'Search', desc: 'Competitive open-source cloud.', color: '#1a73e8' },
  { id: 'groq', name: 'Groq', iconName: 'Zap', desc: 'Ultra-low latency inference.', color: '#f55036' },
  { id: 'mistral', name: 'Mistral', iconName: 'Wind', desc: 'French efficiency & power.', color: '#f5d142' },
  { id: 'together', name: 'Together AI', iconName: 'Layers', desc: 'Scalable open-weights cloud.', color: '#000000' },
  { id: 'minimax', name: 'MiniMax', iconName: 'MessageSquare', desc: 'Advanced conversational AI.', color: '#3b82f6' }
];
